import { render, staticRenderFns } from "./DataTablePesquisarLead.vue?vue&type=template&id=43661c0e"
import script from "./DataTablePesquisarLead.vue?vue&type=script&lang=ts"
export * from "./DataTablePesquisarLead.vue?vue&type=script&lang=ts"
import style0 from "./DataTablePesquisarLead.vue?vue&type=style&index=0&id=43661c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports